document.addEventListener("DOMContentLoaded", function () {

  const tools = document.querySelectorAll(".psh-dosha-tool");

  tools.forEach(function(tool) {

    const button = tool.querySelector(".psh-dosha-button");
    const resultDiv = tool.querySelector(".psh-dosha-result");

    if (!button || !resultDiv) return;

    button.addEventListener("click", function () {

      const scores = {
        vata: 0,
        pitta: 0,
        kapha: 0
      };

      const checkedInputs = tool.querySelectorAll("input[type='radio']:checked");
if (!checkedInputs.length) {
  resultDiv.innerHTML = "<p>Veuillez répondre à au moins une question pour afficher votre Dosha dominant.</p>";
  return;
}
      checkedInputs.forEach(function(input) {
        const value = input.value;

        if (scores[value] !== undefined) {
          scores[value]++;
        }
      });

      let dominant = "vata";

      if (scores.pitta > scores[dominant]) {
        dominant = "pitta";
      }

      if (scores.kapha > scores[dominant]) {
        dominant = "kapha";
      }

      const results = {

        vata: {
          title: "Votre profil dominant semble être : Vata",
          text: "Vous semblez avoir une énergie variable, un esprit créatif et une sensibilité plus marquée au stress ou à la fatigue nerveuse.",
          articles: [
            {
              label: "Méditation et Ayurveda : Trouver la paix intérieure",
              url: "https://pureshilajithimalaya.fr/blogs/la-medecine-ancienne-de-layurveda/meditation-et-ayurveda-trouver-la-paix-interieure"
            },
            {
              label: "L’Ayurveda et le sommeil réparateur : Ritucharya et Dinacharya",
              url: "https://pureshilajithimalaya.fr/blogs/la-medecine-ancienne-de-layurveda/layurveda-et-le-sommeil-reparateur-ritucharya-et-dinacharya"
            }
          ]
        },

        pitta: {
          title: "Votre profil dominant semble être : Pitta",
          text: "Vous semblez avoir une énergie intense, un mental structuré et une forte capacité d’action, avec parfois une tendance à la pression ou à l’irritabilité.",
          articles: [
            {
              label: "L’importance de l’Agni en Ayurveda : Le feu digestif comme clé de la santé",
              url: "https://pureshilajithimalaya.fr/blogs/la-medecine-ancienne-de-layurveda/limportance-de-lagni-en-ayurveda-le-feu-digestif-comme-cle-de-la-sante"
            },
            {
              label: "Yoga et Ayurveda : Une alliance pour l’équilibre",
              url: "https://pureshilajithimalaya.fr/blogs/la-medecine-ancienne-de-layurveda/yoga-et-ayurveda-une-alliance-pour-lequilibre"
            }
          ]
        },

        kapha: {
          title: "Votre profil dominant semble être : Kapha",
          text: "Vous semblez avoir un profil stable, calme et endurant, avec une tendance naturelle à rechercher l’équilibre et la récupération.",
          articles: [
            {
              label: "Ayurveda et gestion du poids : Équilibrer les Doshas pour une silhouette harmonieuse",
              url: "https://pureshilajithimalaya.fr/blogs/la-medecine-ancienne-de-layurveda/ayurveda-et-gestion-du-poids-equilibrer-les-doshas-pour-une-silhouette-harmonieuse"
            },
            {
              label: "Les saisons en Ayurveda : Adapter son mode de vie selon Ritucharya",
              url: "https://pureshilajithimalaya.fr/blogs/la-medecine-ancienne-de-layurveda/les-saisons-en-ayurveda-adapter-son-mode-de-vie-selon-ritucharya"
            }
          ]
        }

      };

      const data = results[dominant];

      let articlesHtml = "";

      data.articles.forEach(function(article) {

        articlesHtml += `
          <a href="${article.url}" class="psh-comparateur-link">
            ${article.label}
          </a>
        `;

      });

      resultDiv.innerHTML = `

        <div class="psh-comparateur-card psh-compare-result">

          <h3>${data.title}</h3>

          <p>${data.text}</p>

          <div class="psh-comparateur-links">

            <strong>Articles recommandés :</strong>

            ${articlesHtml}

            <a href="#"
               class="psh-comparateur-link">
              Les principes fondamentaux de l’Ayurveda : Comprendre les Doshas
            </a>

          </div>

        </div>

      `;

      const yOffset = -120;
      const y = resultDiv.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({
        top: y,
        behavior: "smooth"
      });

    });

  });

});